var React = require('react');

function IcXComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"icons/ic-search"},[React.createElement("rect",{"id":"background","x":"1.1084","y":"1.1665","width":"15.7832","height":"15.6667","stroke":"#3E3E3E","key":0}),React.createElement("path",{"id":"Vector","d":"M12.0572 3.58301H13.7536L10.0474 7.81891L14.4074 13.583H10.9936L8.31973 10.0871L5.26026 13.583H3.56282L7.52693 9.05224L3.34436 3.58301H6.84487L9.26178 6.77839L12.0572 3.58301Z","fill":"#3E3E3E","key":1})]));
}

IcXComponent.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = IcXComponent;

IcXComponent.default = IcXComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/MyTarifSectionV2/images/ic-x.component.svg
// module id = 418
// module chunks = 0